import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.scss';

export default function Footer() {
  return (
    <>
      <footer className="footer bg-dark text-white text-center py-4">
        <div className="container">
          <p>
            &copy; {new Date().getFullYear()} Free Medication Abortion. All
            rights reserved.
          </p>
        </div>
      </footer>

      <a
        href="#"
        id="scroll-top"
        className="scroll-top d-flex align-items-center justify-content-center"
      >
        <i className="bi bi-arrow-up-short"></i>
      </a>
    </>
  );
}
